import '@css/app.css'
import 'lite-youtube-embed/src/lite-yt-embed.css'
import 'lite-youtube-embed'
import 'lite-vimeo-embed'
import Alpine from 'alpinejs'
import logoImage from '../img/logo-aantwerk.png'
import linkedinLogoImage from '../img/linkedin.png'

declare global {
    interface Window {
        Alpine: typeof Alpine;
        logoUrl: string;
        linkedinLogoUrl: string;
    }
}

// Register dropdown handler
Alpine.data('dropdown', () => ({
    dropdownPosition: 'left',
    init() {
        // Update position on hover
        this.$el.addEventListener('mouseenter', () => this.updateDropdownPosition());
        // Update position on window resize
        window.addEventListener('resize', () => this.updateDropdownPosition());
    },
    updateDropdownPosition() {
        const button = this.$el;
        const viewportWidth = window.innerWidth;
        const buttonRect = button.getBoundingClientRect();
        const minDropdownWidth = 200; // Minimum width of dropdown

        // Calculate if there's enough space on the right
        const spaceOnRight = viewportWidth - buttonRect.right;
        
        // If there's not enough space on the right, position to the right
        if (spaceOnRight < minDropdownWidth) {
            this.dropdownPosition = 'right';
        } else {
            this.dropdownPosition = 'left';
        }
    }
}));

window.Alpine = Alpine
Alpine.start()

window.logoUrl = logoImage
window.linkedinLogoUrl = linkedinLogoImage

// Lazy-load PhotoSwipe only on pages that actually contain a sfeerfotos gallery.
// Template renders a [data-photoswipe-gallery] wrapper; the lightbox, its CSS and the
// PhotoSwipe runtime are all dynamically imported so nothing ships on other pages.
if (document.querySelector('[data-photoswipe-gallery]')) {
    void (async () => {
        const [{ default: PhotoSwipeLightbox }] = await Promise.all([
            import('photoswipe/lightbox'),
            import('photoswipe/style.css'),
        ])
        new PhotoSwipeLightbox({
            gallery: '[data-photoswipe-gallery]',
            children: 'a',
            pswpModule: () => import('photoswipe'),
        }).init()
    })()
}